import { useCallback } from "react";

import moment from "moment";

import { useSelectedCycle } from "@pages/mmm/hooks/use-selected-cycle";

export const useSelectedCyclePriorPeriod = () => {
  const { selectedCycle } = useSelectedCycle();

  const getSelectedCyclePriorPeriod = useCallback(() => {
    const currentCycleStart = moment(selectedCycle.date_range.start_date);
    const currentCycleEnd = moment(selectedCycle.date_range.end_date);
    const daysDiff = currentCycleEnd.diff(currentCycleStart, "days");

    const yesterday = moment().subtract(1, "days");
    let prevPeriodEndDate = moment(currentCycleStart).subtract(1, "days");

    if (prevPeriodEndDate.isAfter(yesterday)) {
      prevPeriodEndDate = yesterday;
    }

    const prevPeriodStartDate = moment(prevPeriodEndDate).subtract(
      daysDiff,
      "days",
    );

    return {
      startDate: prevPeriodStartDate.format("YYYY-MM-DD"),
      endDate: prevPeriodEndDate.format("YYYY-MM-DD"),
    };
  }, [selectedCycle.date_range.start_date, selectedCycle.date_range.end_date]);

  return { getSelectedCyclePriorPeriod };
};
